import React from "react";
import useLocalQuery, { Table } from "hooks/useQuery/local-query";
import { Spinner } from "components/ui";
import TableRow from "./table-row"
import PropTypes from "prop-types";

const TableCoaches = ({
  data,
  isFetching,
  openModal
}) => {
  const columns = [
    {
      header: "Name",
      field: "CoachName"
    },
    {
      header: "# of patients",
      field: "TotalPatientsCount"
    },
    {
      header: "# of scheduled patients",
      field: "TotalScheduledPatientsCount"
    },
    {
      header: "# of patients not scheduled",
      field: "TotalNotScheduledPatientsCount"
    },
    {
      header: "# of patients in progress",
      field: "TotalInProgressPatientsCount"
    },
    {
      header: "# of compliance patients",
      field: "TotalCompliancePatientsCount"
    },
    {
      header: "Average contacts",
      field: "AverageContactsCount"
    },
    {
      header: "Average days",
      field: "AverageDays"
    }
  ];

  const { rows = [], query, queryDispatcher } = useLocalQuery(data, {
    sort: { by: "CoachName", direction: "asc" }
  });

  const coachesCards = rows?.length ? rows.filter(x => x.CoachId !== "TotalsRowID") : [];
  const totalsRow = rows?.length ? rows.find(x => x.CoachId === "TotalsRowID") : [];

  return (
    <div style={{ margin: "20px 10px 10px 10px" }}>
      {data && !isFetching && (
        <Table
          containerClass="query-table "
          rows={coachesCards}
          query={query}
          queryDispatcher={queryDispatcher}
          TableRow={props => (
            <TableRow data={props} openModal={openModal} />
          )}
          rowKey="CoachId"
          columns={columns}
          controls={
            <div className="query-table-controls">
              <h2
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "hsla(0, 0%, 100%, 0.6)"
                }}
              >
                Overall data
              </h2>
            </div>
          }
          renderFooter={totalsRow.length &&
            <div style={{ width: "100%", display: "flex", alignItems: "center", minWidth: "1470px" }}>
              <TableRow
                isTotalsRow={true}
                data={totalsRow}
              />
              <div style={{ width: "5px" }} className="total-container">
                <span className="count-label">Count:</span>
                <span className="count-value">{coachesCards?.length}</span>
              </div>
            </div>
          }
        />
      )}
      {isFetching && <Spinner />}
    </div>
  );
};

TableCoaches.propTypes = {
  data: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  openModal: PropTypes.func
};

export default TableCoaches;
